import { Outlet, useParams } from 'react-router';
import AccessDenied from '../util/AccessDenied';
import { useIsOrgAdmin } from './useUserOrganizations';

export default function RequireOrgAdmin() {
  const { organizationId } = useParams<{ organizationId: string }>();
  const isOrgAdmin = useIsOrgAdmin(organizationId);

  if (!organizationId || !isOrgAdmin) {
    return <AccessDenied />;
  }

  return <Outlet />;
}
